var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('article', [_c('activity-stage', {
    attrs: {
      "customRootContainerClass": ("" + (_vm.isMobile || _vm.keyboardEnabled ? '' : 'full-height')),
      "customContentContainerStyles": {
        height: ("" + (_vm.keyboardEnabled ? '100%' : 'calc(100% - 55px)'))
      }
    }
  }, [_c('template', {
    slot: "instructions"
  }, [_vm._t("instructions")], 2), _c('activity-wrapper', {
    attrs: {
      "slot": "content",
      "customStyle": {
        padding: _vm.isTablet ? '10px 75px' : '10px 50px',
        height: ("" + (_vm.getContainerHeight()))
      }
    },
    slot: "content"
  }, [_c('portal', {
    attrs: {
      "to": "multiPart-tabs"
    }
  }, [_c('div', {
    attrs: {
      "id": "multiPart-tab-container"
    }
  }, [_c('article', {
    class: {
      'current-tab': _vm.isOnFirstTab,
      'multiPart-tab': true
    },
    attrs: {
      "aria-label": ("Activity part 1 is currently " + (_vm.isOnFirstTab ? 'active' : 'inactive')),
      "role": "complementary"
    }
  }, [_vm._v("\n            1\n          ")]), _c('article', {
    class: {
      'current-tab': !_vm.isOnFirstTab,
      'multiPart-tab': true
    },
    attrs: {
      "aria-label": ("Activity part 2 is currently " + (_vm.isOnFirstTab ? 'inactive' : 'active')),
      "role": "complementary"
    }
  }, [_vm._v("\n            2\n          ")])])]), _c('div', {
    attrs: {
      "id": "scrollable-text-and-question-container"
    }
  }, [_c('keyboard-adaptation-wrapper', {
    staticClass: "scrollable-text-wrapper",
    attrs: {
      "defaultHeight": 330
    }
  }, [_c('section', {
    attrs: {
      "id": "scrollable-text-section"
    }
  }, [_c('div', {
    staticClass: "focusable",
    staticStyle: {
      "padding": "10px 25px"
    },
    attrs: {
      "id": "scrollable-container",
      "tabindex": "10"
    }
  }, [_c('html-renderer', {
    attrs: {
      "htmlObject": _vm.currentRound.scrollableHtml
    }
  })], 1)])]), _c('keyboard-adaptation-wrapper', {
    class: {
      'question-text-section': true,
      tablet: _vm.isTablet
    },
    attrs: {
      "defaultHeight": 330
    }
  }, [_c('section', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.isOnFirstTab,
      expression: "isOnFirstTab"
    }]
  }, [_c('html-renderer', {
    attrs: {
      "htmlObject": _vm.multiSelectQuestionText
    }
  }), _c('article', {
    staticStyle: {
      "margin-top": "8px"
    },
    attrs: {
      "aria-live": "polite",
      "role": "region"
    }
  }, [_c('i', [_vm._v("* No more than two answers can be selected.")])])], 1), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.isOnFirstTab,
      expression: "!isOnFirstTab"
    }]
  }, [_c('html-renderer', {
    attrs: {
      "htmlObject": _vm.constructAResponseQuestionText
    }
  })], 1), !_vm.isOnFirstTab ? _c('div', {
    staticStyle: {
      "height": "168px"
    }
  }, [_c('text-editor', {
    staticClass: "text-editor",
    attrs: {
      "autoFocus": true,
      "maxLength": _vm.currentRound.constructAResponse && _vm.currentRound.constructAResponse.maxCharacterCount
    },
    model: {
      value: _vm.keyboardHtml,
      callback: function ($$v) {
        _vm.keyboardHtml = $$v;
      },
      expression: "keyboardHtml"
    }
  })], 1) : _vm._e()])])], 1), _c('div', {
    staticClass: "multi-select-container"
  }, [_vm.isOnFirstTab && _vm.currentRound.multiSelect ? _c('section', {
    staticClass: "multi-select-section"
  }, [_c('multi-select-check-boxes', {
    attrs: {
      "answers": _vm.currentRound.multiSelect.answers,
      "lockedAnswers": _vm.lockedCheckBoxSelections,
      "maxCheckBoxSelections": _vm.maxMultiSelectAnswers,
      "resetCheckBoxAfterErrors": true,
      "showErrors": _vm.activityStatus.showErrors,
      "showHints": _vm.activityStatus.showHints,
      "showSuccess": true
    },
    on: {
      "onCheckBoxesSelectionChange": _vm.handleOnCheckBoxesSelectionChange,
      "onSelectDisabledCheckbox": _vm.handleOnSelectDisabledCheckbox
    }
  })], 1) : _vm._e()])], 1)], 2), !_vm.isOnFirstTab ? _c('section', {
    staticClass: "keyboard-container"
  }, [_vm._t("keyboard")], 2) : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }